import { RunChecklistTree } from '@/components/runs/run-by-id.component';
import { Run } from '@/types/run.type';
import { ChecklistStatusIndicator } from '@/types/status-indicators.type';
import { create } from 'zustand';

interface RunChecklistState {
    runChecklistObject: Run | undefined;
    runChecklistTree: RunChecklistTree | undefined;
    statusIndicators: ChecklistStatusIndicator[];
    customStatusIndicators: ChecklistStatusIndicator[];
    runChecklistInstructionsMappingObject: { [key: string]: boolean }
    isSaving: boolean;
    isPreview: boolean;
    isPublic: boolean;
    isBuilderPreview: boolean;
    isStatusIndicatorDisabled: boolean;
    isSingleResponse: boolean;
    setRunChecklistObject: (runChecklistObject: Run) => void;
    setRunChecklistTree: (runChecklistTree: RunChecklistTree) => void;
    refreshRunChecklistTree: () => void;
    setRunChecklistInstructionsMappingObject: (runChecklistInsturctionsMappingObject: { [key: string]: boolean }) => void;
    setIsSaving: (isSaving: boolean) => void;
    reset: () => void;
    setIsPreview: (isPreview: boolean) => void;
    setIsPublic: (isPublic: boolean) => void;
    setIsBuilderPreview: (isBuilderPreview: boolean) => void;
    setIsStatusIndicatorDisabled: (isPublic: boolean) => void;
    setIsSingleResponse: (isPublic: boolean) => void;
}

export const useRunChecklistStore = create<RunChecklistState>((set, get) => ({
    runChecklistObject: undefined,
    runChecklistTree: undefined,
    statusIndicators: [],
    customStatusIndicators: [],
    runChecklistInstructionsMappingObject: {},
    isSaving: false,
    isPreview: false,
    isPublic: false,
    isStatusIndicatorDisabled: false,
    isSingleResponse: false,
    isBuilderPreview: false,

    setRunChecklistObject: (runChecklistObject: Run) => {
        set(() => ({ runChecklistObject: runChecklistObject }));

        if (runChecklistObject) {
            if (
                runChecklistObject?.checklist_version?.checklistByVersionChecklistId
                    ?.checklist_status_indicators &&
                runChecklistObject?.checklist_version?.checklistByVersionChecklistId
                    ?.checklist_status_indicators?.length > 0
            ) {
                set(() => ({ statusIndicators: runChecklistObject?.checklist_version?.checklistByVersionChecklistId?.checklist_status_indicators }));
            } else {
                set(() => ({
                    statusIndicators: [{
                        id: '',
                        name: 'Completed',
                        order_number: 0
                    }]
                }));
            }

            const versionRoot =
              runChecklistObject?.checklist_version
                ?.checklistByVersionChecklistId;
            // console.log('RunStore Object:', runChecklistObject);
            
            if (versionRoot?.checklistsByChecklistId) {
              const list = versionRoot?.checklistsByChecklistId // ← this is the array of child tasks!
                .flatMap(c => c.checklist_status_indicators ?? []);

              if (list && list?.length > 0) {
                set(() => ({
                  customStatusIndicators: list
                }));
              }
            }
        }
    },

    setRunChecklistTree: (runChecklistTree: RunChecklistTree) => {
        set(() => ({ runChecklistTree: runChecklistTree }));
    },

    refreshRunChecklistTree: () => {
        set(state => ({ runChecklistTree: state.runChecklistTree ? { ...state.runChecklistTree } : undefined }));
    },

    setIsSaving: (isSaving: boolean) => {
        set(() => ({ isSaving: isSaving }));
    },

    setRunChecklistInstructionsMappingObject: (runChecklistInsturctionsMappingObject: { [key: string]: boolean }) => {
        set(() => ({ runChecklistInstructionsMappingObject: { ...runChecklistInsturctionsMappingObject } }));
    },

    reset: () => {
        set({
            runChecklistObject: undefined,
            runChecklistTree: undefined,
            statusIndicators: [],
            customStatusIndicators: [],
            runChecklistInstructionsMappingObject: {},
            isSaving: false,
            isPreview: false,
            isBuilderPreview: false,
        }
        )
    },

    setIsPreview: (isPreview: boolean) => {
        set(() => ({ isPreview }));
    },

    setIsPublic: (isPublic: boolean) => {
        set(() => ({ isPublic }));
    },

    setIsBuilderPreview: (isBuilderPreview: boolean) => {
        set(() => ({ isBuilderPreview }));
    },

    setIsStatusIndicatorDisabled: (isStatusIndicatorDisabled: boolean) => {
        set(() => ({ isStatusIndicatorDisabled }));
    },

    setIsSingleResponse: (isSingleResponse: boolean) => {
        set(() => ({ isSingleResponse }));
    }
}));
